module.exports = __webpack_public_path__ + "static/media/thewaygif.f5cf2aad.gif";